import { useCallback } from "react";
import { VideoEvent } from "../../../lib/analytics/utils";
import { useOrcaAdsContext } from "../../contexts/OrcaAdsContext";
import { useVideoDataContext } from "../../contexts/VideoDataContext";

export const useHandleVideoEnd = ({
  autoplayState,
  sendAnalyticsEvent,
  resetVideoState,
  willPlaythrough,
  switchToNextVideo,
  onVideoEnded,
  hasNextRecVideo,
  isFullscreen,
  isNativeIOSPlayer,
  setIsFullscreen
}) => {
  const { shouldShowAds } = useOrcaAdsContext();
  const { resetUniqueId } = useVideoDataContext();
  const handleVideoEnd = useCallback(() => {
    if (!autoplayState.isLooping) sendAnalyticsEvent(VideoEvent.COMPLETE);

    resetVideoState(willPlaythrough && hasNextRecVideo);

    if (willPlaythrough) {
      if (isNativeIOSPlayer && isFullscreen && shouldShowAds) {
        setIsFullscreen(false);
      }
      switchToNextVideo();
    } else {
      // If the video is not playing through to a new video, we need to reset the unique id for analytics
      resetUniqueId();
    }

    onVideoEnded();
  }, [
    autoplayState.isLooping,
    sendAnalyticsEvent,
    resetVideoState,
    willPlaythrough,
    switchToNextVideo,
    onVideoEnded,
    hasNextRecVideo,
    isFullscreen,
    isNativeIOSPlayer,
    setIsFullscreen,
    shouldShowAds,
    resetUniqueId
  ]);

  return handleVideoEnd;
};
